export const GET_SOCIAL_MEDIA_DATA_REQUEST = 'GET_SOCIAL_MEDIA_DATA_REQUEST';
export const GET_SOCIAL_MEDIA_DATA_SUCCESS = 'GET_SOCIAL_MEDIA_DATA_SUCCESS';
export const GET_SOCIAL_MEDIA_DATA_FAILURE = 'GET_SOCIAL_MEDIA_DATA_FAILURE';
